import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import useClickActionT2 from '@/tracks/useClickActionT2';
import LOGO from '@/assets/images/logo/weee-logo-black.svg';
import { twMerge } from 'tailwind-merge';

export type Props = {
  wrapClassName?: string;
  className?: string;
  src?: string;
  isLabel?: boolean;
  onClick?: (e?: React.SyntheticEvent) => void;
};

export default function Logo({ wrapClassName, className, src, isLabel }: Props) {
  const { lang } = useTranslation('common');
  const { buttonClick } = useClickActionT2();

  const logoImg = (
    <img className={twMerge('w-[82px]', className)} src={src || LOGO} aria-label="weee logo" alt="Weee! logo" />
  );

  const trackClick = () => {
    buttonClick({
      mod_nm: null,
      mod_pos: null,
      sec_nm: null,
      sec_pos: null,
      co: {
        target_nm: 'weee_logo',
        target_pos: 0,
        target_type: 'normal_button',
        click_type: 'view'
      }
    });
  };

  if (isLabel) {
    return <div className={twMerge('m-auto', wrapClassName)}>{logoImg}</div>;
  }

  return (
    <a href={`/${lang}`} aria-label="Weee! home page">
      <div
        className="m-auto cursor-pointer"
        onClick={() => {
          trackClick();
        }}>
        {logoImg}
      </div>
    </a>
  );
}
